import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { fetchAndSetUser } from '../../../../../reduxToolkit/slices/commonSlice';
import { useSelector, useDispatch } from '../../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../../services/helper';
import { deleteDocument, getUserDocuments, userFileUpload } from '../../../../../services/services';

export const ProfileFileManagement = () => {
  const event = useSelector((state) => state.common.event);
  const user = useSelector((state) => state.common.user);

  const [isFileUploading, setIsFileUploading] = useState<boolean>(false);
  const [userFiles, setUserFiles] = useState<any[]>([]);
  const { t } = useTranslation('event');

  const dispatch = useDispatch();

  useEffect(() => {
    if (user && event) {
      getUserFiles();
    }
  }, [user]);

  async function deleteFile(fileId: string) {
    deleteDocument(fileId).then(() => {
      dispatch(fetchAndSetUser());
    });
  }
  async function getUserFiles() {
    if (event?.settings.maxUserFileUpload && user) {
      getUserDocuments(event._id).then(({ data }) => {
        setUserFiles([...data]);
      });
    }
  }

  function uploadDocument({ target }: any) {
    if (target?.files[0]) {
      setIsFileUploading(true);
      event &&
        user &&
        userFileUpload(target?.files[0], event._id)
          .then(() => {
            dispatch(fetchAndSetUser());
            setIsFileUploading(false);
            target.value = null;
          })
          .catch(() => {
            setIsFileUploading(false);
          });
    }
  }

  return (
    <>
      {event && event?.settings?.allowUserFileupload && (
        <div className="flex flex-col justify-between w-full mt-3">
          <span className="mb-1">
            {event.settings.userFileUploadDescription ? event.settings.userFileUploadDescription : t('event:live.profile-upload-document')}
            {` (${userFiles.length}/${event?.settings?.maxUserFileUpload})`}
          </span>
          {isFileUploading && <CircularProgress />}
          <List dense>
            {userFiles.map((file: any) => (
              <ListItem>
                <ListItemText
                  style={{ overflow: 'hidden', cursor: 'pointer' }}
                  primary={file.name}
                  onClick={() => window.open(createDisplayLink(file._id), '_blank')}
                />
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="delete" onClick={() => deleteFile(file.id)} size="large">
                    <DeleteIcon
                      sx={{
                        '& path': {
                          fill: 'inherit !important',
                        },
                      }}
                    />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
          {userFiles.length < event.settings.maxUserFileUpload && <input onChange={(e) => uploadDocument(e)} type="file" />}
        </div>
      )}
    </>
  );
};
